import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('notification');

export const state = () => ({
    ...crud.state,
    NEW_SUPPORT_TICKET: 'new_support_ticket',
    NEW_REQUEST: 'new_request'
});

export const getters = {
    ...crud.getters,
    newSupportTicket: state => state.NEW_SUPPORT_TICKET,
    newRequest: state => state.NEW_REQUEST,
    allTypes: state => [state.NEW_SUPPORT_TICKET, state.NEW_REQUEST]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    read(vuexContext, id) {
        return axios.$post(`/admin/notifications/${id}/read`);
    }
};
